module.exports = __webpack_public_path__ + "media/4x3/sz-cfb8269f.svg";